import React from 'react'
import PropTypes from 'prop-types'

import AutosuggestField from '../AutosuggestField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import StarRatingComponent from 'react-star-rating-component'
import StopWatch from '../StopWatch'
import moment from 'moment'
import { DatePicker } from 'material-ui-pickers'
import { CirclePicker } from 'react-color'

class Field extends React.Component {
  renderField () {
    const {
      type,
      name,
      label,
      height,
      value,
      onChange,
      disabled,
      suggestions
    } = this.props

    switch (type) {
      case 'dropdown':
        return <AutosuggestField
          value={value}
          label={label}
          onChange={onChange}
          suggestions={suggestions}
          disabled={disabled}
        />

      case 'checkbox':
        return <FormControlLabel
          control={
            <Checkbox
              checked={value}
              onChange={(event, checked) => onChange(checked)}
            />
          }
          label={label}
          disabled={disabled}
        />
      case 'date':
        return <div className="script-log-template-text-field">
          <DatePicker
            fullWidth
            name={name}
            value={value !== '' ? moment(value) : moment()}
            label={label}
            onChange={date => onChange(date.format('MM-DD-YYYY'))}
            animateYearScrolling={false}
            leftArrowIcon={<i className="zmdi zmdi-arrow-back"/>}
            rightArrowIcon={<i className="zmdi zmdi-arrow-forward"/>}
            disabled={disabled}
          />
        </div>
      case 'color':
        return <div>
          <FormHelperText className="mb-2">{label}</FormHelperText>
          <div style={{position: 'relative'}}>
            <CirclePicker
              width="100%"
              name={name}
              colors={[
                '#3c3cff',
                '#8b4513',
                '#29d698',
                '#2fbfde',
                '#51b858',
                '#1d7021',
                '#729acc',
                '#e384e3',
                '#e732e7',
                '#eda63b',
                '#970097',
                '#f76fa4',
                '#cec195',
                '#008080',
                '#a690e0',
                '#e2e264'
              ]}
              color={value}
              onChange={color => onChange(color.hex)}
            />
            {disabled && <div style={{
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              backgroundColor: 'transparent'
            }}/>}
          </div>
        </div>
      case 'rating':
        return <div>
          <FormHelperText className="mb-2">{label}</FormHelperText>
          <StarRatingComponent
            className="h2 mb-0"
            name={name}
            value={value}
            onStarClick={newValue => {
              if (newValue === value)
                newValue = 0
              onChange(newValue)
            }}
            starCount={5}
            editing={!disabled}
          />
        </div>
      case 'stopwatch':
        return <div>
          <FormHelperText className="mb-2">{label}</FormHelperText>
          <StopWatch
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      default:
        return <div className="script-log-template-text-field">
          <TextField
            name={name}
            label={label}
            margin="normal"
            value={value}
            onChange={event => onChange(event.target.value)}
            fullWidth
            style={{marginTop: 0, marginBottom: 0, height: '100%'}}
            disabled={disabled}
            multiline={height > 63}
            rows={Math.floor((height - 44) / 19)}
          />
        </div>
    }
  }

  render () {
    return <div className="script-log-template-field">
      {this.renderField()}
    </div>
  }
}

Field.propTypes = {
  type: PropTypes.oneOf(['text', 'dropdown', 'checkbox', 'date', 'color', 'rating', 'stopwatch']),
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  height: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  suggestion: PropTypes.array
}

Field.defaultProps = {
  type: 'text',
  height: 63,
  disabled: false,
  suggestion: [],
  value: ''
}

export default Field



// WEBPACK FOOTER //
// ./components/ScriptLogTemplate/Field.js